import { render, staticRenderFns } from "./LitterRegistrationRequest.vue?vue&type=template&id=51703cd4"
import script from "./LitterRegistrationRequest.vue?vue&type=script&lang=ts"
export * from "./LitterRegistrationRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports